import { render } from "./homeIndex.vue?vue&type=template&id=ec1eda96"
import script from "./homeIndex.vue?vue&type=script&lang=js"
export * from "./homeIndex.vue?vue&type=script&lang=js"

import "./homeIndex.vue?vue&type=style&index=0&id=ec1eda96&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__